export default __webpack_public_path__ + "static/media/sdk-tokens.f46bc7ae.svg";